import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth/auth.service';
import { EventsService } from 'src/app/services/events/events.service';

export const HISTORY_GUARD_KEY = 'historyVisited';

@Injectable({
  providedIn: 'root'
})
export class HistoryGuard  {

  constructor(private alertController: AlertController, private authService: AuthService, private translate: TranslateService, private eventService: EventsService) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
      const isComplete = localStorage.getItem(HISTORY_GUARD_KEY);
      let user = this.authService.getUser();
      
      if (user && !(isComplete && (isComplete === 'true'))) {
        localStorage.setItem(HISTORY_GUARD_KEY, "true");
        this.welcomeHistory();
      }
      return true;
  }

  public welcomeHistory(){
    let title = this.translate.instant("history.alerts.title");
    let content = this.translate.instant("history.alerts.content");
    this.eventService.publish("disableBackButtonHistory", "history guard");
    this.alertController
    .create({
      message: `<div><img class="" src="assets/img/historyAlert.svg" alt=""></img></div><div><p class='font-bold rose-icon font-size-20'>${title}</p></div><div><p>${content}</p></div>`,
      backdropDismiss: false,
      cssClass: "welcomeHistory",
      animated: true,
      buttons: [
        {
          text: this.translate.instant("history.alerts.button"),
          cssClass: "alert-button-custom flex-center",
          role: "cancel",
          handler: () => {
            console.log("Boton back");
            this.eventService.publish("enableBackButtonHistory", "history guard");
          },
        },
      ],
    })
    .then((res) => {
      res.present();
    });
  }
  
}
